import React, { forwardRef } from "react";
import ReactDOM from "react-dom";
import { styled } from "goober";
import { usePortalContainer } from "clutch/src/util/use-portal-container.mjs";

import ClientOnly from "@/util/ClientOnly.jsx";

const BlitzPortalContainer = styled("div", React.forwardRef)`
  position: absolute;
  inset: 0;
  pointer-events: none;
  > * {
    pointer-events: auto;
  }
`;

// Render to the blitz-app-container
// Since our exit routes use use transform, we cannot use fixed.
// Therefore to work around this we can render to the container
// with view absolute
export default forwardRef<
  HTMLDivElement,
  {
    fromElement?: React.RefObject<HTMLElement>;
  } & React.ComponentPropsWithoutRef<"div">
>(function BlitzPortal({ fromElement, ...restProps }, ref) {
  const portalContainer = usePortalContainer({
    fromElement,
  });

  return (
    <ClientOnly>
      {portalContainer &&
        ReactDOM.createPortal(
          <BlitzPortalContainer ref={ref} {...restProps} />,
          portalContainer,
        )}
    </ClientOnly>
  );
});
